import { useContext, useEffect } from "react";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";

import { Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import useListAction from "@beeldit/core/actions/list/useListAction";
import useCreateAction from "@beeldit/core/actions/create/useCreateAction";
import useInitialize from "@beeldit/core/actions/create/useInitialize";
import useEditAction from "@beeldit/core/actions/edit/useEditAction";
import useRemoveAction from "@beeldit/core/actions/remove/useRemoveAction";
import { getTableConfig } from "@beeldit/core/helpers/tables";
import { CreateActionProvider as ChargesCreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import chargesConfig from "@main/charges/config";

function DebtsTableInner(props: any) {
  const { modelConfig, templates, modalSize, formDefaultValues, filters } = props;
  const { user } = useContext(AuthContext);

  const location = useLocation();

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(modelConfig, user, filters);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(modelConfig, indexFunction, formDefaultValues);

  const { getFunction, actionTemplate: editActionTemplate } = useEditAction(
    modelConfig,
    indexFunction,
    modalSize
  );

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(modelConfig, indexFunction);

  // charges create modal and initializer run inside ChargesCreateActionProvider
  const { actionTemplate: createChargeTemplate } = useCreateAction(
    chargesConfig,
    indexFunction,
    {}
  );
  const initializeCharge = useInitialize();

  /** Table configuration definition */
  let tableConfig = getTableConfig(modelConfig.tableConfig, {
    indexFunction: indexFunction,
    actionsFunctions: [
      {
        name: "create",
        function: initializeFunction,
      },
    ],
    rowFunctions: [
      {
        name: "edit",
        function: getFunction,
      },
      {
        name: "delete",
        function: prepareRemoveFunction,
      },
      {
        // our custom create-charge function: opens charges create modal with debt preselected
        name: "create-charge",
        function: (debtId: any) => {
          if (typeof initializeCharge === "function") {
            initializeCharge({ debt_id: debtId });
          }
        },
      },
    ],
  });
  setTableConfig(tableConfig);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const isNew = urlParams.get("new");
    if (isNew === "true") {
      initializeFunction();
    }
  }, [location, initializeFunction]);

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <h2 className="card-header-title">
          <span>{t(modelConfig.modelPluralName)}</span>
        </h2>
        <div>
          <BeelditTableHeaderActions actions={tableConfig.actions} />
        </div>
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {editActionTemplate}
        {removeActionTemplate}
        {createChargeTemplate}
        {templates &&
          templates.map((template: any, index: number) => {
            return { template };
          })}
      </Card.Body>
    </Card>
  );
}

function DebtsTablePage(props: any) {
  return (
    <ChargesCreateActionProvider>
      <DebtsTableInner {...props} />
    </ChargesCreateActionProvider>
  );
}

export default DebtsTablePage;
